/**
 * Curated Google Fonts available for school owners to customize their
 * landing + school-side UI. Each entry maps to:
 *  - `family`   : full Google Fonts family name (used in CSS font-family)
 *  - `gfUrl`    : Google Fonts CSS link href (single weight set per family)
 *  - `category` : "sans" | "serif" | "display" — purely for UI labelling
 */
export const FONT_OPTIONS = [
  { family: "Inter",               gfUrl: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap", category: "sans" },
  { family: "Poppins",             gfUrl: "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap", category: "sans" },
  { family: "Playfair Display",    gfUrl: "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;800&display=swap", category: "serif" },
  { family: "Montserrat",          gfUrl: "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap", category: "sans" },
  { family: "Lora",                gfUrl: "https://fonts.googleapis.com/css2?family=Lora:wght@400;500;600;700&display=swap", category: "serif" },
  { family: "Raleway",             gfUrl: "https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700;800&display=swap", category: "sans" },
  { family: "Nunito",              gfUrl: "https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap", category: "sans" },
  { family: "Outfit",              gfUrl: "https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap", category: "sans" },
  { family: "DM Sans",             gfUrl: "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap", category: "sans" },
  { family: "Manrope",             gfUrl: "https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap", category: "sans" },
  { family: "Plus Jakarta Sans",   gfUrl: "https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap", category: "sans" },
  { family: "Merriweather",        gfUrl: "https://fonts.googleapis.com/css2?family=Merriweather:wght@400;700;900&display=swap", category: "serif" },
];

export const FONT_FAMILIES = FONT_OPTIONS.map((f) => f.family);

/** Inject the Google Fonts <link> tag for a family if it isn't already loaded. */
export function ensureFontLoaded(family) {
  if (!family) return;
  const def = FONT_OPTIONS.find((f) => f.family === family);
  if (!def) return;
  const id = `sb-font-${family.replace(/\s+/g, "-")}`;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = def.gfUrl;
  document.head.appendChild(link);
}

/**
 * Apply heading/body/button fonts as CSS variables on `:root`.
 * Pass `null` for any role to clear it (falls back to the SchoolBoss defaults
 * defined in index.css).
 *
 * @param {{heading?: string|null, body?: string|null, button?: string|null}} fonts
 */
export function applyFonts({ heading, body, button } = {}) {
  const root = document.documentElement;
  const set = (varName, family) => {
    if (family) {
      ensureFontLoaded(family);
      root.style.setProperty(varName, `'${family}', system-ui, sans-serif`);
    } else {
      root.style.removeProperty(varName);
    }
  };
  set("--sb-font-heading", heading);
  set("--sb-font-body", body);
  set("--sb-font-button", button);
}
